import React, { useEffect, useState } from "react";
import { Grid, Link } from "@mui/material";
import axios from "axios";
import axiosInstanceInterceptor from "../utils/axiosInstanceInterceptor";
import { getOrRefreshBearerToken } from "../services/bearerToken.service";
import { API_VERSION } from "../utils/commonConstant";

const HeaderLogo = ({ clientId, heading }) => {
  const [clientDetails, setClientDetails] = useState(null);

  const fetchClientDetails = async () => {
    try {
        const API_BASE_URL = `${process.env.REACT_APP_BASE_API_URL}${API_VERSION}`;
      let bearerToken = await getOrRefreshBearerToken();
      const response = await axiosInstanceInterceptor.get(
        `${API_BASE_URL}Client/GetClientDetailById?clientId=${clientId}`,
        {
          headers: {
            "Authorization": `Bearer ${bearerToken}`, // Add the token here
           // "Content-Type": "application/json", // Optional, if required by the API
          },
        }
      );
      setClientDetails(response.data);
    } catch (error) {
      console.error("Error fetching client details:", error);
    }
  };

  useEffect(() => {
    if (clientId) {
      fetchClientDetails();
    }
  }, [clientId]);

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      spacing={2}
      sx={{ marginBottom: 2 }}
    >
      <Grid item xs={12} sm="auto" display="flex" justifyContent="center">
        <Link href={`/${clientId}`}>
          <img
            src={
              clientDetails
                ? `data:image/png;base64,${clientDetails.LogoImageData}`
                : null
            }
            alt={clientDetails ? clientDetails.Name : "Client Logo"}
            style={{ width: "80px", marginRight: "20px" }}
          />
        </Link>
      </Grid>
      <Grid item xs={12} sm="auto">
        <h2 style={{ textAlign: "center" }}>
          {heading ?? clientDetails?.Name}
        </h2>
      </Grid>
    </Grid>
  );
};

export default HeaderLogo;
